/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnReferralResponse
 */
export interface EarnReferralResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EarnReferralResponse
     */
    claimed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EarnReferralResponse
     */
    alreadyClaimed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EarnReferralResponse
     */
    capReached?: boolean;
}

/**
 * Check if a given object implements the EarnReferralResponse interface.
 */
export function instanceOfEarnReferralResponse(value: object): value is EarnReferralResponse {
    if (!('claimed' in value) || value['claimed'] === undefined) return false;
    if (!('alreadyClaimed' in value) || value['alreadyClaimed'] === undefined) return false;
    return true;
}

export function EarnReferralResponseFromJSON(json: any): EarnReferralResponse {
    return EarnReferralResponseFromJSONTyped(json, false);
}

export function EarnReferralResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnReferralResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimed': json['claimed'],
        'alreadyClaimed': json['alreadyClaimed'],
        'capReached': json['capReached'] == null ? undefined : json['capReached'],
    };
}

export function EarnReferralResponseToJSON(json: any): EarnReferralResponse {
    return EarnReferralResponseToJSONTyped(json, false);
}

export function EarnReferralResponseToJSONTyped(value?: EarnReferralResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimed': value['claimed'],
        'alreadyClaimed': value['alreadyClaimed'],
        'capReached': value['capReached'],
    };
}

